import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from 'process';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class AdminServiceService {

  constructor(private http:HttpClient) { }


  deleteQuestion(type, id){

    this.http.get(`${environment.apiBaseUrl}/${type}/getArray`).subscribe(
      resp=>{
        var data;
        data = resp;
        var array = data.data;
        array.splice(array.indexOf(id),1);
        var body = {
          _id:data._id,
          questions:array
        }
        this.http.post(`${environment.apiBaseUrl}/${type}/updateArray`,body).subscribe(
          r=>{
            window.location.reload();
          },
          err=>console.log(err)
        )

      },
      err=>{
        return err
      }
    )
  }

  toggleQuestions(type, a, b){
    console.log(a,b)
    this.http.get(`${environment.apiBaseUrl}/${type}/getArray`).subscribe(
      resp=>{

        var data;
        data = resp;
        var array = data.data;
        var aux = array[a];
   
        if (a>b) {
          array.splice(a,1)
          array.splice(b,0,aux);

        }else{
          array.splice(b,0,aux);
          array.splice(a,1)
        }
   
        var body = {
          _id:data._id,
          questions:array
        }
        this.http.post(`${environment.apiBaseUrl}/${type}/updateArray`,body).subscribe(
          r=>{
            //window.location.reload();
          },
          err=>console.log(err)
        )

      },
      err=>console.log(err)


    )
  }

  deleteFactor(type, id):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/${type}/deleteFactor`, {_id:id});
  }

  getPlans():Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/plans/getPlans`);
  }

  updatePlan(data):Observable<any>{
    return this.http.put(`${environment.apiBaseUrl}/plans/updatePlan`, data);
  }

  mpPayment(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/payments/mpCheckout`, data);
  }

  paypalPayment(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/payments/paypalOrder`, data);
  }
  savePayment(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/payments/savePayment`, data);
  }

  getPayments():Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/payments/getPayments`);
  }

  createMpSubscription(email: string, type: string, price: number):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/payments/createMpSubscription`, {
      email: email,
      type: type,
      price: price
    });
  }

  cancelMpSubscription(subscriptionId: string):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/payments/cancelMpSubscription`, {
      subscriptionId: subscriptionId
    });
  }

  cancelPayPalSubscription(subscriptionId: string):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/payments/cancelPayPalSubscription`, {
      subscriptionId: subscriptionId
    });
  }

}
